export interface IMEIValidateAPIRequestData {
  imei: string;
}

export interface IMEIValidateAPIResultItem {
  manufacturerBrandDescription: string;
  makeReference?: string;
  serials: Array<string>;
  models: Array<IMEIValidateAPIResultItemModel>;
}

export interface IMEIValidateAPIResultItemModel {
  name: string;
  colour?: string;
  storage?: string;
  modelReference?: string;
}

export type IMEIStatusEnumType = 'IMEI_INVALID' | 'IMEI_NOT_FOUND';
export const IMEIStatusEnum = {
  Invalid: 'IMEI_INVALID' as IMEIStatusEnumType,
  NotFound: 'IMEI_NOT_FOUND' as IMEIStatusEnumType,
};

export interface ValidateAPIErrorResponseData {
  status: IMEIStatusEnumType;
  message: string;
}
